import { general } from './general';

export const text = (data = {}) => general('text', (data || {}));
